var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm._elTag,{tag:"component",staticClass:"tsa-radio-group",attrs:{"role":"radiogroup"},on:{"keydown":_vm.handleKeydown}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }